<template>
  <div id="header">
    <router-link to="/index" class="logo" title="亿车科技">
      <img src="~@/common/img/yiclogo-05.svg" style="width:160px; "/>    
    </router-link>
    <ul
      class="nav-bar"
      @mouseleave="currentItem = {}"
      @click="currentItem = {}"
    >
      <!-- @mouseleave="currentItem = {}" -->
      <li
        v-for="(item, i) in list"
        :key="i"
        :class="{ active: canActive(item) || currentItem === item }"
        @click="clickItem(item)"
        @mouseenter="currentItem = item"
      >
        {{ item.name }}
        <!-- <div v-if="i === 4" class="city-icon">
          <img src="./images/hot.png" alt="" />
        </div> -->
      </li>
      <!-- <router-link style=" text-decoration: none;" to="/campusemployPilotage"> -->
      <!-- <div class="campus" @click="tocampus">
        校园招聘 <span class="campue-icon"></span>
      </div> -->
      <!-- </router-link> -->

      <div>
        <div class="hover-components-wrapper" v-if="currentItem.hoverComponetName">
          <component class="content" :is="currentItem.hoverComponetName"></component>
      </div>
      </div>
    </ul>
  </div>
</template>

<script>
// import forAbout from './hover-components/for-about';
import forIndex from './hover-components/for-index';
import forProductCenter from './hover-components/for-product-center';
import forParkbees from './hover-components/for-parkbees';
import urlMaps from '@/common/urlMaps';
export default {
  components: {
    // forAbout,
    forIndex,
    forProductCenter,
    forParkbees,
  },
  data() {
    return {
      indexPath: urlMaps.首页,
      list: [
        {
          url: '/index',
          name: '首页',
        },
        {
          url: '/Solve',
          name: '解决方案',
          hoverComponetName: 'forIndex',
        },
        {
          url: '/product',
          name: '产品中心',
          hoverComponetName: 'forProductCenter',
        },
        // { url: urlMaps.车主服务, name: '车主服务' },
        // { url: urlMaps.开放平台, name: '开放平台' },
        {
          url: '/parkbees',
          name: '蜜蜂停车',
          hoverComponetName: 'forParkbees',
        },
        { url: '/news', name: '新闻中心' },
        {
          url: '/about',
          name: '关于亿车',
          // hoverComponetName: 'forAbout',
        },
        { url: '/connect', name: '联系我们' },
        // { url: '/campusemploy', name: '校园招聘' },
      ],
      currentItem: {},
    };
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    tocampus() {
      this.$router.push('/about/campusemploy');
    },
    canActive(item) {
      const { url, activeKey } = item;
      const matcher = url || activeKey;
      if (!matcher) return false;
      return this.currentPath.includes(matcher);
    },
    clickItem(item) {
      const { url } = item;
      if (!url) return;
      if (url.includes('http')) {
        window.location.href = url;
        return;
      }
      if (url === '/citypartner') {
        window.open(
          `${window.location.origin}${window.location.pathname}#/citypartner`,
        );
        return;
      }
      this.$router.push(url);
    },
  },
};
</script>
<style lang="scss">
@import './variable.scss';

.campus:hover {
  background: #e4572b;
  color: #fff;
}

.campus {
  margin-left: 32px;
  // height: 100%;
  border: 1px solid #e4572b;
  padding: 0 12px;
  border-radius: 20px;
  color: #e4572b;
  margin-bottom: 4px;
  font-size: 15px;
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;

  &:hover {
    background: #e4572b;
    color: #fff;
  }

  .campue-icon {
    position: absolute;
    right: -18px;
    top: -14px;
    display: block;
    width: 20px;
    height: 20px;
    background: url(./images/mcampus-icon.png) no-repeat;
  }
}

#header {
  height: $headerHeight;
  width: $contentWidth;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .nav-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    // margin-left: 248px;
    margin-left: 100px;
    font-size: 16px;
    height: 100%;

    li:nth-child(5) {
      position: relative;

      .city-icon {
        position: absolute;
        top: 0;
        right: 8px;
      }
    }
    > li {
      width: 60px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      margin-left: 18px;
      cursor: pointer;
      color: $normal-font-color;
      border-bottom: 4px solid transparent;
      &.active {
        color: $highlight-font-color;
        border-bottom-color: #df581a;
      }
    }
  }
  .hover-components-wrapper {
    position: absolute;
    top: $headerHeight;
    z-index: 10;
    left: 0;
    width: 100%;
    background-color: #fff;
    border-top: 1px solid #edecec;
    border-bottom: 1px solid #edecec;
    padding-bottom: 10px;
    line-height: 0;
    cursor: auto;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1);
    > .content {
      width: $contentWidth;
      margin: 0 auto;
      min-height: 120px;
    }
  }
}
</style>
